import { Box, Button, Container, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Header from '../Components/Header'
import { Link } from 'react-router-dom'
import bgImage from "../Images/Featureshero1.jfif";
import wallpaper1 from "../Images/background1.png";
import wallpaper2 from "../Images/background2.png";
import wallpaper3 from "../Images/background3.png";
import wallpaper4 from "../Images/background4.png";
import callingbtn1 from "../Images/buttonstyle1.png";
import callingbtn2 from "../Images/buttonstyle2.png";
import callingbtn3 from "../Images/buttonstyle3.png";
import callingbtn4 from "../Images/buttonstyle4.png";
import feature1 from '../Images/feature1.png';
import feature2 from '../Images/feature2.png';
import feature3 from '../Images/feature3.png';
import feature4 from '../Images/feature4.png';
import feature5 from '../Images/feature5.png';
import feature6 from '../Images/feature6.png';
import feature7 from '../Images/feature7.png';
import feature8 from '../Images/feature8.png';
import feature9 from '../Images/feature9.png';
import feature10 from '../Images/feature10.png';
import feature11 from '../Images/feature11.png';
import feature12 from '../Images/feature12.png';
import { FaStar, FaUser } from 'react-icons/fa';
import Dailog1 from "../Images/icalllogo3.png";
import Upbutton from '../upbutton/Upbutton';
import Footer from '../Components/Footer';
import Aos from "aos";
import "aos/dist/aos.css";
import { MdArrowRight } from 'react-icons/md';
import { CiAlarmOn } from 'react-icons/ci';
import { LuMessageCircleMore } from 'react-icons/lu';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import CloseIcon from '@mui/icons-material/Close';
import Loader from '../Loader/Loader';

const cardData = [
    {
        title: 'Fake Call',
        description: 'Simulate incoming calls to escape awkward moments or situations.',
        image: feature1,
        alt: 'Fake Call Feature',
        bgColor: '#fce4ec94',
    },
    {
        title: 'Caller Wallpaper',
        description: 'Customize your caller screen with vibrant, personal wallpapers.',
        image: feature2,
        alt: 'Caller Wallpaper',
        bgColor: '#e3f2fd',
    },
    {
        title: 'Caller Button Style',
        description: 'Select from stylish and user-friendly call button designs.',
        image: feature3,
        alt: 'Caller Button Style',
        bgColor: '#e8f5e9',
    },
    {
        title: 'Flash on Call',
        description: 'Enable LED flash alerts for incoming calls — ideal in silent mode.',
        image: feature4,
        alt: 'Flash Alerts',
        bgColor: '#fff3e0',
    },
    {
        title: 'Dynamic Ringtones',
        description: 'Assign unique ringtones to contacts or groups with ease.',
        image: feature5,
        alt: 'Dynamic Ringtones',
        bgColor: '#fce4ec94',
    },
    {
        title: 'Call Back Screen',
        description: 'Redesign your callback screen with themes and layout options.',
        image: feature6,
        alt: 'Call Back Screen',
        bgColor: '#e3f2fd',
    },
    {
        title: 'Backup Contacts',
        description: 'Securely back up and restore contacts anytime, anywhere.',
        image: feature7,
        alt: 'Backup Contacts',
        bgColor: '#e8f5e9',
    },
    {
        title: 'Keypad Sound',
        description: 'Customize or enable keypad tones for a tailored dial experience.',
        image: feature8,
        alt: 'Keypad Sound',
        bgColor: '#fff3e0',
    },
    {
        title: 'Call Blocker',
        description: 'Easily block spam and unwanted calls for a hassle-free experience.',
        image: feature9,
        alt: 'Call Blocker',
        bgColor: '#fce4ec94',
    },
    {
        title: 'Quick Response',
        description: 'Send instant predefined messages when you can’t answer.',
        image: feature10,
        alt: 'Quick Response',
        bgColor: '#e3f2fd',
    },
    {
        title: 'Dark Mode',
        description: 'Reduce eye strain and save battery with a sleek dark theme.',
        image: feature11,
        alt: 'Dark Mode',
        bgColor: '#e8f5e9',
    },
    {
        title: 'Call Announcer',
        description: 'Hear caller names aloud — perfect for driving or multitasking.',
        image: feature12,
        alt: 'Call Announcer',
        bgColor: '#fff3e0',
    },
];

const buttons = [
    { src: callingbtn1, borderColor: '#ff532e' },
    { src: callingbtn2, borderColor: '#000' },
    { src: callingbtn3, borderColor: 'rgb(106, 110, 199)' },
    { src: callingbtn4, borderColor: 'rgb(72, 149, 64)' },
];
const wallpapers = [wallpaper1, wallpaper2, wallpaper3, wallpaper4];

const Features2 = () => {
    const callingbtns = [callingbtn1, callingbtn2, callingbtn3, callingbtn4];
    const [selectedWallpaper, setSelectedWallpaper] = useState(wallpaper1);
    const [selectedCallingButton, setSelectedCallingButton] = useState(callingbtn1);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [selectwall, setSelectwall] = useState(null)
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [massage, setMassage] = useState(null);
    const [calling, setCalling] = useState(false);
    const [data, setData] = useState(null);

    const token = "cowberryapps.icallphonedialer.contactbook";
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`http://localhost:5000/scrape?url=https://play.google.com/store/apps/details?id=${token}`);
                console.log('Full Response:', response.data);
                setData(response.data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, []);
    useEffect(() => {
        Aos.init({
            duration: 1000,
            easing: "ease-in-out",
            once: true,
        });
        const timer = setTimeout(() => {
            setLoading(false);
        }, 3000);
        return () => clearTimeout(timer);
    }, []);
    // ===== dialog pages ====
    const handleClickopen = () => {
        if (!selectedWallpaper && !selectedCallingButton) {
            setMassage('Please select a wallpaper or calling button.');
            return;
        }
        setOpen(true);
        // setSelectedWallpaper(null);
        // setSelectedCallingButton(null);
        setCalling(false)
    };
    const handleClose = () => {
        setOpen(false);
    }
    // ====== wallpaper change button ====
    const handleImageChange = () => {
        if (!selectedWallpaper) return;
        const currentIndex = wallpapers.indexOf(selectedWallpaper);
        const nextIndex = (currentIndex + 1) % wallpapers.length;
        setSelectedWallpaper(wallpapers[nextIndex]);
        setSelectwall(nextIndex)
    };
    // ======== calling button change button =====
    const handleCallingButtonChange = () => {
        if (!selectedCallingButton) return;
        const currentIndex = callingbtns.indexOf(selectedCallingButton);
        const nextIndex = (currentIndex + 1) % callingbtns.length;
        setSelectedCallingButton(callingbtns[nextIndex]);
        setSelectedIndex(nextIndex);
    }
    // =======imgclick handler======
    const handleWallpaperClick = (wallpaper) => {
        setSelectedWallpaper(wallpaper);
        setMassage(null);
    };
    // ======== calling button click handler =====
    const handleCallingButtonClick = (imageSrc) => {
        setSelectedCallingButton(imageSrc);
        setMassage(null);
        setCalling(true);
    };
    if (loading) {
        return (
            <div className="App">
                <Loader />
            </div>
        );
    }
    return (
        <Box>
            <Helmet>
                <title>Features - iCall Phone Dialer & Contacts</title>
            </Helmet>
            {/* ====== header ====== */}
            <Box>
                <Header />
            </Box>
            <Box sx={{ height: { xs: '56px', sm: '70px' } }} />
            {/* ====== img sections ===== */}
            <Box sx={{
                backgroundImage: `url(${bgImage})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                height: { md: '400px', xs: "300px" },
                display: 'flex',
                alignItems: 'center',
            }}>
                <Box sx={{
                    width: '100%',
                    height: '100%',
                    bgcolor: 'rgba(0, 0, 0, 0.6)',
                    display: 'flex',
                    alignItems: 'center',
                }}>
                    <Container maxWidth="xl">
                        <Box>
                            <Typography
                                variant="h4"
                                sx={{
                                    color: "#fff",
                                    textAlign: 'center',
                                    fontWeight: 700,
                                    fontSize: { md: '34px', sm: '30px', xs: '24px' }
                                }}
                            >
                                App Features
                            </Typography>
                            <Typography variant='h6' sx={{ textAlign: 'center', marginTop: '10px' }}>
                                <Link to={"/"} style={{ textDecoration: 'none', color: '#fff' }}> Home /</Link> <span style={{ fontWeight: '700', color: "rgb(64, 153, 247)" }}> Features</span>
                            </Typography>
                        </Box>
                    </Container>
                </Box>
            </Box>
            {/* ====  features trynow ==== */}
            <Box Box data-aos="fade-up"
                sx={{
                    backgroundColor: '#f4f6f8',
                    paddingBottom: '50px',
                }}>
                <Container maxWidth="xl">
                    <Typography className='mainheading'
                        variant="h4"
                        sx={{
                            paddingTop: { md: '100px', sm: '60px', xs: '30px' },
                            fontSize: { md: '42px', sm: '30px', xs: '24px' }
                        }}
                    >
                        Wallpaper & Button Customization
                    </Typography>
                    <Typography
                        className='maindescption'
                        variant="body1"
                        sx={{
                            textAlign: 'center',
                            margin: '0px auto',
                            maxWidth: 700,
                            mt: 2,
                        }}
                    >
                        Customize your iCall experience by setting your own wallpaper and adjusting the button colors to match your style.
                    </Typography>
                    <Box sx={{ width: '100%', display: 'flex', flexWrap: 'wrap', gap: "20px", marginTop: { md: '50px', xs: '30px' }, alignItems: 'center' }}>
                        {/* ======= wallpaper and button set class ===== */}
                        <Box sx={{ width: { md: 'calc(60% - 10px)', xs: '100%' } }}>
                            <Typography
                                variant="h5"
                                sx={{
                                    color: '#212121d4',
                                    fontWeight: 700,
                                    fontSize: { md: '28px', sm: '26px', xs: '18px' }
                                }}
                            >
                                Set a Wallpaper
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    color: '#757575',
                                    letterSpacing: '0.5px',
                                    lineHeight: 1.6,
                                    mt: 2,
                                }}
                            >
                                * Select one wallpaper from the options below
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    color: '#757575',
                                    letterSpacing: '0.5px',
                                    lineHeight: 1.6,
                                }}
                            >
                                * Click the "Next" button to view more wallpapers
                            </Typography>
                            {/* ===== set a wallpaper ==== */}
                            <Box
                                sx={{
                                    width: '100%',
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: '20px',
                                    marginTop: { md: '20px', xs: '10px' },
                                }}
                            >
                                {wallpapers.map((wallpaper, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            width: { sm: 'calc(25% - 15px)', xs: 'calc(50% - 10px)' },
                                        }}
                                    >
                                        <img
                                            src={wallpaper}
                                            alt={`wallpaper-${index}`}
                                            width="100%"
                                            height="100%"
                                            onClick={() => {
                                                handleWallpaperClick(wallpaper);
                                                setSelectwall(index);
                                            }}
                                            style={{
                                                cursor: 'pointer',
                                                borderRadius: '10px',
                                                border: `2px solid ${selectwall === index ? 'rgb(64, 153, 247)' : 'gray'}`,
                                                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                            }}
                                            onMouseOver={e => {
                                                e.currentTarget.style.transform = ' scale(1.04)';
                                            }}
                                            onMouseOut={e => {
                                                e.currentTarget.style.transform = 'none';
                                                e.currentTarget.style.boxShadow = 'none';
                                            }}
                                        />
                                    </Box>
                                ))}
                            </Box>
                            {/* ======  wallpaper next Button ====== */}
                            <Box sx={{ marginTop: '10px' }}>
                                <Button onClick={handleImageChange} sx={{
                                    padding: '5px 40px', backgroundColor: 'rgb(64, 153, 247)', color: '#fff', '&:hover': {
                                        backgroundColor: '#000'
                                    }
                                }}>
                                    Next
                                </Button>
                            </Box>
                            <Typography
                                variant="h5"
                                sx={{
                                    color: '#212121d4',
                                    fontWeight: 700,
                                    fontSize: { md: '28px', sm: '26px', xs: '18px' },
                                    mt: 3
                                }}
                            >
                                Set a Calling Button
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    color: '#757575',
                                    letterSpacing: '0.5px',
                                    lineHeight: 1.6,
                                    mt: 2
                                }}
                            >
                                * Select one Calling Button from the options below
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    color: '#757575',
                                    letterSpacing: '0.5px',
                                    lineHeight: 1.6,
                                }}
                            >
                                * Click the "Next" button to view more calling button
                            </Typography>
                            {/* ===== set a calling button ==== */}
                            <Box sx={{
                                width: '100%',
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '20px',
                                marginTop: { md: '20px', xs: '10px' },
                            }}>
                                {buttons.map((button, index) => (
                                    <Box
                                        key={index}
                                        onClick={() => {
                                            setSelectedIndex(index);
                                            handleCallingButtonClick(button.src);
                                        }}
                                        sx={{
                                            width: { sm: 'calc(25% - 15px)', xs: 'calc(50% - 10px)' },
                                            padding: '10px',
                                            border: `2px solid ${selectedIndex === index ? 'rgb(64, 153, 247)' : 'gray'}`,
                                            borderRadius: '10px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        <img
                                            src={button.src}
                                            alt=""
                                            style={{ width: '100%', }}
                                        />
                                    </Box>
                                ))}
                            </Box>
                            {/* ======calling next Button ====== */}
                            <Box sx={{ marginTop: '10px' }}>
                                <Button onClick={handleCallingButtonChange} sx={{
                                    padding: '5px 40px', backgroundColor: 'rgb(64, 153, 247)', color: '#fff', '&:hover': {
                                        backgroundColor: '#000'
                                    }
                                }}>
                                    Next
                                </Button>
                            </Box>
                            <Typography
                                variant="body1"
                                sx={{
                                    color: '#757575',
                                    letterSpacing: '0.5px',
                                    lineHeight: 1.6,
                                    mt: 2
                                }}
                            >
                                * Click the "Apply Now" button to view more information.
                            </Typography>
                        </Box>
                        {/* ====== mobail view class ===== */}
                        <Box sx={{
                            width: { md: 'calc(40% - 10px)', xs: '100%' },
                            position: 'relative',
                        }}>
                            <Typography
                                variant="h5"
                                sx={{
                                    color: '#212121d4 ',
                                    fontWeight: 700,
                                    fontSize: { md: '28px', sm: '26px', xs: '18px' },
                                    textAlign: 'center',
                                }}
                            >
                                Mobile View
                            </Typography>
                            <Box sx={{
                                marginTop: { md: '20px', xs: '10px' },
                                width: { lg: '60%', md: '70%', sm: '50%', xs: '100%' },
                                margin: '0 auto',
                                height: { md: '650px', xs: '600px' },
                                backgroundColor: '#000',
                                borderRadius: '35px',
                                position: 'relative',
                                border: '2px solid #000',
                                overflow: 'hidden',
                            }}>
                                <Box sx={{
                                    position: 'absolute',
                                    top: '10px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    width: '80px',
                                    height: '15px',
                                    borderRadius: '50px',
                                    backgroundColor: '#333',
                                    // backgroundColor: '#fff',
                                }} />
                                <Box sx={{
                                    position: 'absolute',
                                    top: '100px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    fontSize: '30px',
                                    padding: '10px 15px',
                                    backgroundColor: '#000',
                                    border: '2px solid #ffffff59',
                                    color: '#fff',
                                    borderRadius: '50px'
                                }}>
                                    <FaUser />
                                </Box>
                                <Box sx={{
                                    position: 'absolute',
                                    top: '170px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    fontSize: '30px',
                                    color: '#fff',
                                }}>
                                    <Typography variant='h5' sx={{
                                        fontWeight: 500,
                                    }}>
                                        Maribelle
                                    </Typography>
                                </Box>
                                <Box sx={{
                                    position: 'absolute',
                                    top: '230px',
                                    textAlign: 'center',
                                    fontSize: '20px',
                                    color: '#D32F2F',
                                    left: '35px',
                                    maxWidth: '200px',
                                }}>
                                    <Typography variant='body1' sx={{
                                        fontWeight: 500,
                                    }}>
                                        {massage}
                                    </Typography>
                                </Box>
                                {calling && (
                                    <Box sx={{
                                        position: 'absolute',
                                        top: { md: '320px', xs: '400px' },
                                        left: '35px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        width: 'calc(100% - 70px)',
                                        color: '#fff',
                                    }}>
                                        <Box sx={{ textAlign: 'center', flex: 1 }}>
                                            <CiAlarmOn size={30} />
                                            <Typography variant="body1" sx={{
                                                letterSpacing: '0.5px',
                                                lineHeight: 1.6,
                                                fontSize: "14px"
                                            }}>
                                                Reminds Me
                                            </Typography>
                                        </Box>
                                        <Box sx={{ textAlign: 'center', flex: 1 }}>
                                            <LuMessageCircleMore size={30} />
                                            <Typography variant="body1" sx={{
                                                letterSpacing: '0.5px',
                                                lineHeight: 1.6,
                                                fontSize: "14px"
                                            }}>
                                                Message
                                            </Typography>
                                        </Box>
                                    </Box>
                                )}
                                {selectedWallpaper && (
                                    <img
                                        src={selectedWallpaper}
                                        alt="Wallpaper"
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            borderRadius: '35px',
                                        }}
                                    />
                                )}
                                {selectedCallingButton && (
                                    <img
                                        src={selectedCallingButton}
                                        alt="Calling Button"
                                        style={{
                                            position: 'absolute',
                                            bottom: '30px',
                                            left: '50%',
                                            transform: 'translateX(-50%)',
                                            height: '80px',
                                            width: '180px',
                                            objectFit: 'contain',
                                            zIndex: 10,
                                        }}
                                    />
                                )}
                            </Box>
                            {/* ====== Apply button === */}
                            <Box sx={{ marginTop: { md: '20px', xs: '10px' }, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Button onClick={handleClickopen}
                                    sx={{
                                        padding: '10px 40px',
                                        backgroundColor: "rgb(64, 153, 247)",
                                        color: '#fff',
                                        borderRadius: '10px',
                                        width: { sm: '60%', xs: '100%' }, '&:hover': {
                                            backgroundColor: '#000'
                                        }
                                    }}>
                                    Apply Now
                                </Button>
                            </Box>
                            {/* ==== dialog pages === */}
                            <Dialog
                                open={open}
                                onClose={handleClose}
                                fullWidth
                                maxWidth={false}
                                PaperProps={{
                                    sx: {
                                        maxWidth: '900px',
                                        width: '90%',
                                        m: 'auto',
                                        borderRadius: 2,
                                        overflow: 'hidden'
                                    }
                                }}
                            >
                                <DialogTitle sx={{ m: 0, p: 1, position: 'relative' }}>
                                    {/* Empty or title text if you want */}
                                    <IconButton
                                        aria-label="close"
                                        onClick={handleClose}
                                        sx={{
                                            position: 'absolute',
                                            right: 8,
                                            top: 8,
                                            color: (theme) => theme.palette.grey[800],
                                        }}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                </DialogTitle>
                                <DialogContent sx={{ padding: '10px' }}>
                                    <Typography variant='h6' sx={{
                                        textAlign: 'center',
                                        color: '#212121d4 ',
                                        maxWidth: '500px',
                                        margin: 'auto',
                                        marginBottom: '30px',
                                        fontWeight: 700,
                                        fontSize: { md: '22px', sm: '20px', xs: '18px' },
                                    }}>
                                        Download the app now to set these on your phone’s call screen!
                                    </Typography>
                                    <Box sx={{ width: '100%', display: 'flex', flexWrap: 'wrap', gap: '20px', mb: 2 }}>
                                        <Box sx={{ width: { sm: 'calc(50% - 10px)', xs: '100%' } }}>
                                            <Box sx={{ maxWidth: { sm: '320px', xs: '100px' }, margin: '0px auto' }}>
                                                <a
                                                    href="https://play.google.com/store/apps/details?id=cowberryapps.icallphonedialer.contactbook"
                                                    style={{ maxWidth: '100%', display: 'block' }}
                                                >
                                                    <img
                                                        src={Dailog1}
                                                        alt="Application"
                                                        style={{
                                                            width: '100%',
                                                            height: 'auto',
                                                            display: 'block',
                                                        }}
                                                    />
                                                </a>
                                            </Box>
                                        </Box>
                                        <Box sx={{ width: { sm: 'calc(50% - 10px)', xs: '100%' } }}>
                                            <Typography
                                                variant="h5"
                                                sx={{
                                                    color: '#212121d4 ',
                                                    fontWeight: 700,
                                                    fontSize: { md: '28px', sm: '26px', xs: '18px' },
                                                }}
                                            >
                                                iCall Phone Dialer & Contacts
                                            </Typography>
                                            <Typography
                                                variant="body1"
                                                sx={{
                                                    color: '#757575',
                                                    fontWeight: 400,
                                                    lineHeight: 1.7,
                                                    mt: 2
                                                }}
                                            >
                                                <span><MdArrowRight /> Flash on Call</span>
                                                <span><MdArrowRight /> Personalized Wallpapers</span><br />
                                                <span><MdArrowRight /> Dynamic Ringtones</span>
                                                <span><MdArrowRight /> Smart Call Tools</span><br />
                                                <span><MdArrowRight /> Custom Call Screen</span>
                                                <span><MdArrowRight /> DND Mode</span><br />
                                                <span><MdArrowRight /> Call Recording</span>
                                                <span><MdArrowRight /> Dark Mode</span><br />
                                                <span><MdArrowRight /> Call Announcer</span>
                                                <span><MdArrowRight /> Fake Call</span><br />
                                            </Typography>
                                            <Box sx={{ width: '100%', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: '10px', mt: 2, alignItems: 'center' }}>
                                                <Box>
                                                    <Typography variant='h6'
                                                        sx={{
                                                            color: '#212121d4',
                                                            fontWeight: '500',
                                                            textAlign: 'center'
                                                        }}>
                                                        {data ? data.rating.slice(0, 3) : '4.0'}
                                                        <FaStar style={{ fontSize: '15px' }} />
                                                    </Typography>
                                                    <Typography variant='body1'
                                                        sx={{
                                                            color: '#757575',
                                                        }}>
                                                        {data ? data.reviews : '500+ reviews'}
                                                    </Typography>
                                                </Box>
                                                <Box>
                                                    <Typography variant='h6'
                                                        sx={{
                                                            color: '#212121d4',
                                                            fontWeight: '500',
                                                            textAlign: 'center'
                                                        }}>
                                                        {data ? data.downloads : "100K+"}
                                                    </Typography>
                                                    <Typography variant='body1'
                                                        sx={{
                                                            color: '#757575',
                                                        }}>
                                                        Downloads
                                                    </Typography>
                                                </Box>
                                                <Box>
                                                    <Typography variant='h6'
                                                        sx={{
                                                            color: '#212121d4',
                                                            fontWeight: '500',
                                                            textAlign: 'center',
                                                            border: '1px solid #212121d4',
                                                            maxWidth: '30px',
                                                            margin: '0px auto'
                                                        }}>
                                                        {data ? data.contentRating.slice(9) : "3+"}
                                                    </Typography>
                                                    <Typography variant='body1'
                                                        sx={{
                                                            color: '#757575',
                                                        }}>
                                                        {data ? data.contentRating : "Rated for 3+"}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <Box sx={{ mt: 2 }}>
                                                <a style={{
                                                    color: '#fff',
                                                    textDecoration: 'none',
                                                    width: '100%',
                                                    // textAlign: 'center',
                                                    display: 'block'
                                                }} href="https://play.google.com/store/apps/details?id=cowberryapps.icallphonedialer.contactbook">
                                                    <Button
                                                        fullWidth
                                                        sx={{
                                                            backgroundColor: 'rgb(1, 135, 95)',
                                                            padding: '10px',
                                                            '&:hover': { backgroundColor: '#000' },
                                                            // textTransform: 'none',
                                                            textDecoration: 'none',
                                                            color: "#fff"
                                                        }}>
                                                        Install
                                                    </Button>
                                                </a>
                                            </Box>
                                        </Box>
                                    </Box>
                                </DialogContent>
                            </Dialog>
                        </Box>
                    </Box>
                </Container>
            </Box>
            {/* ===== alll features ==== */}
            <Box data-aos="fade-up"
                sx={{
                    marginTop: { md: '100px', sm: '60px', xs: '30px' },
                }}>
                <Container maxWidth="xl">
                    <Typography className='mainheading'
                        variant="h4"
                        sx={{
                            fontSize: { md: '42px', sm: '30px', xs: '24px' }
                        }}
                    >
                        All Features
                    </Typography>
                    <Typography
                        className='maindescption'
                        variant="body1"
                        sx={{
                            textAlign: 'center',
                            margin: '0px auto',
                            maxWidth: 700,
                            mt: 2,
                        }}
                    >
                        iCall is a fast, lightweight, and intelligent phone dialer and contact manager designed to make calling effortless
                    </Typography>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '20px',
                            mt: { md: '50px', xs: '30px' },
                            justifyContent: { xs: 'center', md: 'space-between' },
                        }}
                    >
                        {cardData.map((card, index) => (
                            <Box
                                component={Link}
                                to='https://play.google.com/store/apps/details?id=cowberryapps.icallphonedialer.contactbook'
                                key={index}
                                sx={{
                                    width: {
                                        xs: '100%',
                                        sm: 'calc(50% - 20px)',
                                        md: 'calc(33.33% - 20px)',
                                        lg: 'calc(25% - 20px)',
                                    },
                                    textDecoration: 'none'
                                }}
                            >
                                <Box
                                    sx={{
                                        padding: '20px',
                                        height: { md: '100%', xs: 'auto' },
                                        backgroundColor: card.bgColor,
                                        borderRadius: '12px',
                                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                                        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                        '&:hover': {
                                            transform: 'translateY(-5px)',
                                            boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12)',
                                        },
                                    }}
                                >
                                    <Box>
                                        <img
                                            src={card.image}
                                            alt={card.alt}
                                            width="100%"
                                        />
                                    </Box>
                                    <Typography
                                        className='cardlooptitle'
                                        variant="h5"
                                        sx={{
                                            mt: 2,
                                            fontSize: { md: '22px', xs: '20px' },
                                        }}
                                    >
                                        {card.title}
                                    </Typography>
                                    <Typography
                                        className='cardloopdesc'
                                        variant="body1"
                                        sx={{
                                            mt: '10px',
                                        }}
                                    >
                                        {card.description}
                                    </Typography>
                                </Box>
                            </Box>
                        ))}
                    </Box>
                </Container>
            </Box>
            {/* ======= footer ===== */}
            <Box sx={{ marginTop: { md: '100px', sm: '60px', xs: '30px' } }}>
                <Footer />
            </Box>
            {/* ======= Uopbutton ===== */}
            <Box>
                <Upbutton />
            </Box>
        </Box>
    )
}
export default Features2 